import { auditReports } from '@mi-front/api-clients';
import { useToast } from '@app/core/notifications';
import NotStartedIcon from '@mui/icons-material/NotStarted';
import { IconButton, Tooltip } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useIntl } from 'react-intl';

export function AodScheduledRunActions({
  scheduledRun,
  ruleId,
}: {
  scheduledRun: auditReports.ScheduledAodRunDto;
  ruleId: string;
}) {
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const { notifySuccess } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const triggerManualRunMutation = auditReports.useTriggerManualRunFromScheduledAodRules();

  const handleTriggerRun = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      await triggerManualRunMutation.mutateAsync({
        scheduledJobId: scheduledRun.jobId,
      });

      // Invalidate scheduled runs queries to refresh the data
      queryClient.invalidateQueries({
        queryKey: auditReports.getAodRulesScheduledRunsQueryKey(ruleId),
      });

      notifySuccess(
        formatMessage({
          id: 'audit.aod.runs.actions.triggerRunCopySuccess',
          defaultMessage: 'Ejecución iniciada',
        }),
      );
    } catch (error) {
      console.error('Failed to trigger manual run:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip
      title={formatMessage({
        id: 'audit.aod.runs.actions.triggerRunCopy',
        defaultMessage: 'Ejecutar copia ahora',
      })}
    >
      <IconButton onClick={handleTriggerRun} disabled={isLoading} color="primary">
        <NotStartedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
